export type Meters = number;
export type Kilometers = number;

export const metersToKilometers = (meters: Meters): Kilometers => meters / 1000;

export const toFormattedDistance = (
  value: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number
): string =>
  Intl.NumberFormat('pt-BR', {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
